import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const ButtonsTableContent = styled.div`
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: flex-end;
  height: auto;
  margin-bottom: 1.5rem;
  padding: 15px;
  border-radius: 10px;

  button {
    &:first-child {
      margin-right: 0.5rem;
    }
  }
`;

export const MultipleDownloadContainer = styled.div`
  margin-top: 3rem;
`;
